export default __webpack_public_path__ + "static/media/img-tp2.9655aa3b.png";